import React, { useMemo } from "react";
import Rule from "pages/SettingsAutoResponse/components/Rule";
import { Field, FieldArray } from "formik";
import Conditions from "pages/SettingsAutoResponse/components/Conditions";
import Condition from "pages/SettingsAutoResponse/components/Condition";
import ConditionField from "pages/SettingsAutoResponse/components/ConditionField";
import SelectField from "components/SelectField";
import View from "components/View";
import AddConditionButton from "pages/SettingsAutoResponse/components/AddConditionButton";

const languageArray = [
  { label: "English", value: "en" },
  { label: "Russian", value: "ru" }
];

const operators = [
  { label: "Is", value: "is" },
  { label: "Is not", value: "isNot" }
];

function LanguageRuleContainer({ language }) {
  const additionalLanguage = useMemo(() => {
    return languageArray.filter(i => {
      return language.map(l => {
        if (l.language === i.value) {
          i.hide = true;
        }
        return l;
      });
    });
  }, [language]);

  return (
    <Rule
      title={
        <>
          <svg xmlns="http://www.w3.org/2000/svg" width="19px" height="19px">
            <path d="M19.001,9.848 L19.000,9.848 L19.000,10.000 L18.974,10.000 C18.854,12.280 17.944,14.350 16.497,15.926 C16.501,15.931 16.504,15.935 16.509,15.939 L16.482,15.939 C14.854,17.706 12.560,18.847 10.000,18.980 L10.000,19.000 L9.847,19.000 L9.847,19.001 L9.499,19.001 L9.151,19.001 L9.151,19.000 L9.000,19.000 L9.000,18.980 C6.439,18.847 4.146,17.707 2.514,15.939 L2.490,15.939 C2.494,15.935 2.498,15.930 2.503,15.926 C1.054,14.351 0.144,12.280 0.024,10.000 L0.000,10.000 L0.000,9.848 L-0.002,9.848 L-0.002,9.151 L0.000,9.151 L0.000,9.000 L0.017,9.000 C0.270,4.153 4.152,0.271 9.000,0.020 L9.000,0.000 L10.000,0.000 L10.000,0.020 C14.848,0.273 18.729,4.155 18.980,9.000 L19.000,9.000 L19.000,9.150 L19.001,9.150 L19.001,9.848 ZM10.000,8.990 L10.000,9.000 L13.000,9.000 C12.974,7.442 12.924,6.170 12.610,4.934 C11.787,5.219 10.909,5.384 10.000,5.431 L10.000,8.990 ZM5.868,10.000 C5.897,11.225 6.024,12.388 6.242,13.427 C7.108,13.109 8.036,12.927 9.000,12.876 L9.000,10.001 L8.988,10.000 L5.868,10.000 ZM18.000,10.001 L13.999,10.001 C13.977,11.379 13.691,12.531 13.425,13.699 C14.369,14.129 15.232,14.707 15.980,15.406 C17.328,13.927 17.916,12.138 18.000,10.001 ZM15.464,15.926 C14.808,15.317 14.061,14.808 13.241,14.422 C12.804,15.990 12.163,17.260 11.397,18.061 C12.945,17.720 14.341,16.968 15.464,15.926 ZM10.000,18.171 C11.092,17.808 12.030,16.296 12.589,14.145 C11.778,13.841 10.907,13.662 10.000,13.610 L10.000,18.171 ZM10.000,12.877 C10.964,12.927 11.892,13.109 12.756,13.426 C12.984,12.343 12.980,11.284 13.000,10.001 L10.000,10.001 L10.000,10.009 L10.000,12.877 ZM9.000,18.172 L9.000,13.610 C8.094,13.661 7.222,13.840 6.410,14.145 C6.969,16.297 7.909,17.810 9.000,18.172 ZM7.601,18.061 C6.836,17.260 6.193,15.990 5.755,14.422 C4.938,14.808 4.191,15.317 3.535,15.926 C4.656,16.968 6.052,17.720 7.601,18.061 ZM3.018,15.406 C3.768,14.707 4.629,14.129 5.574,13.699 C5.318,12.575 5.169,11.321 5.138,10.000 L0.757,10.000 C0.875,12.077 1.702,13.963 3.018,15.406 ZM1.000,9.000 L5.000,9.000 C5.028,7.353 5.370,5.997 5.728,4.677 C4.873,4.306 4.084,3.814 3.380,3.221 C1.823,4.737 1.094,6.653 1.000,9.000 ZM3.931,2.727 C4.538,3.227 5.213,3.647 5.940,3.970 C6.366,2.681 6.938,1.633 7.601,0.938 C6.231,1.242 4.978,1.864 3.931,2.727 ZM9.000,1.001 C7.954,1.239 7.187,2.315 6.588,4.228 C7.348,4.495 8.160,4.652 9.000,4.699 L9.000,1.001 ZM6.388,4.934 C6.074,6.171 6.025,7.444 6.000,9.000 L9.000,9.000 L9.000,5.431 C8.092,5.384 7.212,5.220 6.388,4.934 ZM10.000,1.001 L10.000,1.012 L10.000,4.698 C10.840,4.651 11.651,4.495 12.411,4.228 C11.811,2.315 11.047,1.239 10.000,1.001 ZM11.397,0.938 C12.062,1.633 12.631,2.681 13.057,3.970 C13.786,3.647 14.461,3.227 15.069,2.727 C14.020,1.864 12.769,1.242 11.397,0.938 ZM15.618,3.221 C14.915,3.814 14.126,4.308 13.270,4.677 C13.629,5.998 13.973,7.353 13.999,9.000 L18.000,9.000 C17.907,6.652 17.175,4.737 15.618,3.221 Z" />
          </svg>
          LANGUAGE
        </>
      }
    >
      <FieldArray
        name="language"
        render={arrayHelpers => {
          return (
            <>
              {language.length > 0 && (
                <Conditions>
                  {language.map((item, index) => {
                    return (
                      <Condition onDelete={() => arrayHelpers.remove(index)}>
                        <ConditionField>
                          <Field
                            name={`language.${index}.operator`}
                            component={SelectField}
                            placeholder="Select a condition"
                            items={operators}
                          />
                        </ConditionField>
                        {language[index].operator && (
                          <ConditionField>
                            <Field
                              name={`language.${index}.language`}
                              component={SelectField}
                              placeholder="Select value"
                              items={additionalLanguage}
                            />
                          </ConditionField>
                        )}
                      </Condition>
                    );
                  })}
                </Conditions>
              )}
              {language.length < 1 && (
                <View display="inline-flex">
                  <AddConditionButton
                    title="Add condition"
                    onClick={() =>
                      arrayHelpers.push({ operator: "", language: "" })
                    }
                  />
                </View>
              )}
            </>
          );
        }}
      />
    </Rule>
  );
}
export default LanguageRuleContainer;
